<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="d_flex_btwn">
          <h5 class="common_subtitle pb_20  font_16p pt_20">Policy </h5>
        </div>

        <div class="d_flex_start pt_10 pb_10">
          <button v-if="can('policy_create')" type="button" class="btn btn-outline-primary btn-sm mr_15 width_120p" @click="openModal()">
            Create Policy
          </button>
          <button v-if="can('policy_edit')" type="button" class="btn btn-outline-info btn-sm mr_15 width_100p" @click.prevent="openModal(selectedRecord.id)"
                  :disabled="!selectedRecord || !selectedRecord.id">
            Edit
          </button>
          <button v-if="can('policy_delete')" type="button" class="btn btn-outline-danger btn-sm mr_15 width_100p" @click.prevent="deleteRecord()"
                  :disabled="!selectedRecord || !selectedRecord.id">
            Delete
          </button>
          <button v-if="can('policy_view_permission')" type="button" class="btn btn-outline-info btn-sm mr_15 width_260p"
                  @click.prevent="viewPermission(selectedRecord)" :disabled="!selectedRecord || !selectedRecord.id">View
            Permission
          </button>
          <button type="button" class="btn btn-outline-primary btn-sm width_100p" @click.prevent="loadData()">
            Refresh
          </button>
        </div>

        <cloud-table-component
            :columns="columns"
            :rows="inquiries"
            :sortable="sortable"
            :pagination="pagination"
            @sorting="sorting"
            @pageChanged="pageChanged">
          <template v-slot:id="{ row }">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" :id="'action_'+row.id"
                     @focus="checkSingleData(row, $event)" :checked="selectedRecord?.id === row.id">
              <label class="form-check-label" :for="'action_'+row.id"></label>
            </div>
          </template>

        </cloud-table-component>
      </div>
    </div>

    <BaseModal
        v-if="isShowInquiryModal"
        :title="modalTitle"
        :closeModal="closeModal"
        size="modal_1080p"
    >
      <PolicyForm
          :closeModal="closeModal"
          :loadData="loadData"
          :editId="editId"
      />
    </BaseModal>

    <BaseModal
        v-if="isShowPolicyViewModal"
        :closeModal="closeModal"
        title="Permission"
        size="modal_1080p"
    >
      <PolicyPermissionView
          :closeModal="closeModal"
          :permissions="permissionList"
      />
    </BaseModal>

  </div>
</template>

<script>
import CloudTableComponent from "@/components/shared/CloudTableComponent.vue";
import PolicyForm from "@/views/iam/PolicyForm.vue";
import BaseModal from "@/components/BaseModal.vue";
import PolicyPermissionView from "@/views/iam/PolicyPermissionView.vue";
import { useAbility } from '@casl/vue';

export default {
  name: "Policy",
  components: {PolicyPermissionView, BaseModal, PolicyForm, CloudTableComponent},
  setup() {
    const { can } = useAbility();

    return {
      can
    };
  },
  data() {
    return {
      inquiries: [],
      filter: {},
      queryParams: {
        page: 1,
        search: '',
        search_columns: 'user_id,email,phone,policy.name,policyGroup.name',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 10
      },
      sortable: {
        order: 'created_at',
        sort: 'desc'
      },
      columns: [
        {
          label: "",
          field: "id",
          sortable: false,
          slot: true,
        },
        {
          label: "Policy Name",
          field: "name",
          sortable: true,
        },
        {
          label: "Explanation",
          field: "description",
          sortable: true,
        },
      ],
      pagination: null,
      isShowInquiryModal: false,
      editId: null,
      selectedRecord: null,
      isShowPolicyViewModal: null,
      permissionList: null,
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === from.name && !window._.isEqual(to, from)) {
        this.setQueryData(this.getAllQueryParams())
        this.loadData()
      }
    },
  },
  computed: {
    modalTitle() {
      if (this.editId) {
        return 'Edit Policy';
      } else {
        return 'Add New Policy';
      }
    }
  },
  mounted() {
    const query = this.getAllQueryParams()
    if (query.page) {
      this.setQueryData(query)
    }
    this.loadData()
  },
  methods: {
    setQueryData(query) {
      this.queryParams = {
        page: query.page,
        search: query.search,
        search_columns: query.search_columns,
        sort: query.sort,
        sort_order: query.sort_order,
        per_page: query.per_page
      }

      this.filter = {}

      this.sortable = {
        order: query.sort,
        sort: query.sort_order
      }
    },
    resetAll() {
      this.sortable = {
        order: 'created_at',
        sort: 'desc'
      }

      this.filter = {}

      this.queryParams = {
        page: 1,
        search: '',
        search_columns: 'user_id,email,phone,policy.name,policyGroup.name',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 10
      }

      this.changeRoute();
      this.loadData();
    },
    searchQuery() {
      this.changeRoute();
    },
    sorting({column, order}) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
      this.queryParams.page = 1;
      this.changeRoute()
    },
    pageChanged(page) {
      this.queryParams.page = page;
      this.changeRoute()
    },
    changeRoute() {
      this.$router.push({name: this.$route.name, query: {...this.queryParams, ...this.filter}})
    },
    loadData() {
      this.lyLoading = true
      this.axios.get('/policies', {
        params: {...this.queryParams, ...this.filter}
      })
          .then(({data}) => {
            this.inquiries = data.data
            this.pagination = data.meta;
          })
          .finally(() => {
            this.lyLoading = false;
            this.selectedRecord = null;
          })
    },
    openModal(editId = null) {
      this.editId = editId
      this.isShowInquiryModal = true;
    },
    closeModal() {
      this.isShowInquiryModal = false;
      this.isShowPolicyViewModal = false;
    },
    checkSingleData(user, event) {
      event.target.blur();
      if (this.selectedRecord?.id === user.id) {
        this.selectedRecord = null;
      } else {
        this.selectedRecord = user;
      }
    },
    deleteRecord() {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/policies/' + this.selectedRecord.id)
              .then((response) => {
                if (response.data.success) {
                  this.selectedRecord = null;
                  this.showSuccessMsg(response.data.message);
                  this.loadData();
                } else {
                  this.showFailMsg(response.data.message)
                }
              });
        }
      });
    },
    viewPermission(policy) {
      this.permissionList = policy.policyPermissions
      this.isShowPolicyViewModal = true
    }
  }
}
</script>

<style scoped>

</style>